import { DialogOverlay } from '@reach/dialog'
import styled from 'styled-components'

import { BANNER_HEIGHT_DESKTOP } from 'constants/announcement'
import useClickOutside from 'hooks/useClickOutside'
import { setOpenModal } from 'state/app/reducer'
import { selectShowBanner } from 'state/app/selectors'
import { selectOpenMarketDropdownList } from 'state/futures/common/selectors'
import {
	selectIsDraggingSlider,
	selectSelectedChart,
	selectShowHistory,
} from 'state/futures/selectors'
import { useAppDispatch, useAppSelector } from 'state/hooks'
import { media } from 'styles/media'

import FundingChart from '../FundingChart'
import PositionChart from '../PositionChart'
import { TRADE_PANEL_WIDTH_LG, TRADE_PANEL_WIDTH_MD } from '../styles'
import MarketsDropdownList from '../Trade/MarketsDropdownList'
import GlobalTradesHistoryTable from '../TradingHistory/GlobalTradesHistoryTable'

const ChartWrapper = () => {
	const dispatch = useAppDispatch()
	const showHistory = useAppSelector(selectShowHistory)
	const selectedChart = useAppSelector(selectSelectedChart)
	const openMarketDropdownList = useAppSelector(selectOpenMarketDropdownList)
	const isDraggingSlider = useAppSelector(selectIsDraggingSlider)

	const { ref } = useClickOutside(() => dispatch(setOpenModal(null)))
	const showBanner = useAppSelector(selectShowBanner)

	return (
		<Container $showHistory={showHistory} isDraggingSlider={isDraggingSlider}>
			{openMarketDropdownList && (
				<StyledDialogOverlay>
					<DropdownContainer showBanner={showBanner} ref={ref}>
						<MarketsDropdownList mobile={false} />
					</DropdownContainer>
				</StyledDialogOverlay>
			)}
			<div className="charts-container">
				<PositionChart display={selectedChart === 'price'} />
				<FundingChart display={selectedChart === 'funding'} />
			</div>
			<GlobalTradesHistoryTable display={showHistory} />
		</Container>
	)
}

const StyledDialogOverlay = styled(DialogOverlay)`
	z-index: 10;
	background: rgba(0, 0, 0, 0.5);
`

const DropdownContainer = styled.div<{ showBanner: boolean }>`
	position: absolute;
	z-index: 100;
	top: calc(122px + ${(props) => (props.showBanner ? BANNER_HEIGHT_DESKTOP : 0)}px);
	${media.greaterThan('lg')`
		left: ${TRADE_PANEL_WIDTH_LG}px;
	`}
	${media.lessThan('lg')`
		left: ${TRADE_PANEL_WIDTH_MD}px;
	`}
`

const Container = styled.div<{ $showHistory: boolean; isDraggingSlider: boolean }>`
	display: flex;
	height: 100%;
	overflow: hidden;

	.charts-container {
		${(props) => props.isDraggingSlider && 'pointer-events: none;'}
		width: ${(props) => (props.$showHistory ? 'calc(100% - 300px)' : '100%')};
	}
`

export default ChartWrapper
